import AdsClickRoundedIcon from "@mui/icons-material/AdsClickRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import MarkChatReadRoundedIcon from "@mui/icons-material/MarkChatReadRounded";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import { Badge, Box } from "@mui/material";
import { grey } from "@mui/material/colors";

interface IInteractionsCellProperties {
  interactions: {
    bounced: boolean;
    clicked: number;
    lead: boolean;
    opened: number;
    responded: number;
  };
  theme: any;
}

const InteractionsCell = ({ interactions, theme }: IInteractionsCellProperties) => {
  const iconColor = theme.palette.success.main;

  return (
    <Box display={"contents"}>
      <Box sx={{ display: "flex", gap: 3, justifyContent: "center", padding: "0 10px" }}>
        {interactions.bounced ? (
          <RemoveCircleRoundedIcon style={{ color: theme.palette.error.main, height: 20, width: 20 }} />
        ) : (
          <>
            <Badge
              badgeContent={interactions.opened}
              sx={{ "& .MuiBadge-badge": { backgroundColor: "#000", color: "white" } }}
            >
              <MarkEmailReadRoundedIcon
                style={{
                  color: interactions.opened > 0 ? iconColor : grey[500],
                  height: 20,
                  width: 20,
                }}
              />
            </Badge>
            <Badge
              badgeContent={interactions.clicked}
              sx={{ "& .MuiBadge-badge": { backgroundColor: "#000", color: "white" } }}
            >
              <AdsClickRoundedIcon
                style={{
                  color: interactions.clicked > 0 ? iconColor : grey[500],
                  height: 20,
                  width: 20,
                }}
              />
            </Badge>
            <Badge
              badgeContent={interactions.responded}
              sx={{ "& .MuiBadge-badge": { backgroundColor: "#000", color: "white" } }}
            >
              <MarkChatReadRoundedIcon
                style={{
                  color: interactions.responded > 0 ? iconColor : grey[500],
                  height: 20,
                  width: 20,
                }}
              />
            </Badge>
            {interactions.lead ? (
              <EmojiEventsRoundedIcon style={{ color: iconColor, height: 20, width: 20 }} />
            ) : (
              <Badge badgeContent="" sx={{ "& .MuiBadge-badge": { backgroundColor: "transparent" } }}>
                <EmojiEventsRoundedIcon style={{ color: grey[500], height: 20, width: 20 }} />
              </Badge>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default InteractionsCell;
